<template>
  <div class="table-content-wrapper w-100 h-100">
    <div class="table-container">
      <slot />
    </div>
  </div>
</template>